import React, { useState, useCallback } from "react"
import { FaIcon, Link } from "lib"

const RenderLink = ({item, i, handleActivate, IconComp}) => {
   const [open, setOpen] = useState(false)
    const handleToggle = useCallback(() => {
        setOpen(open => !open)
    }, [])

   return (
    <li key={i} className={item.items && item.items.length > 0 ? "has-submenu" : ""}>
        <div className={`menu-item ${open ? " open" : ""}`}>
        {item.items && item.items.length > 0 && (
            <div className="menu-opener" onClick={handleToggle}><FaIcon icon="faAngleRight" /></div>
        )}
        <Link to={item.p} onActivate={handleActivate}>
            {IconComp} {item.title}
        </Link>
        </div>
        {item.items && open && (
            <ul className="menu">
                {item.items.map((item, i) => <RenderLink item={item} key={i} handleActivate={handleActivate}/>)}
            </ul>
        )}
    </li>
   )
}
const MobileMenu = ({ id, menu, language, onActivate }) => {
    //const [mainMenu] = useSubscription("mainMenu")
    //console.log(menus)
    //const { mainMenu, secMenu }
    const [open, setOpen] = useState(false)
    const handleToggle = useCallback(() => {
        setOpen(open => !open)
    }, [])
    const handleActivate = useCallback(() => {
        setOpen(false)
        return true
    }, [])
    if (!menu) return null

    return (
        <>
            <div id="mobile-menu-button" onClick={handleToggle}>
                <FaIcon icon="faBars" />
            </div>
            <div id="mobile-menu" className={open ? "open" : ""}>
                <div>
                    {menu && (
                        <ul key={1} className="mobile-main-menu">
                            {menu.map((item, i) => <RenderLink item={item} key={i} handleActivate={handleActivate}/>)}
                        </ul>
                    )}
                </div>
            </div>
        </>
    )
}

export default React.memo(MobileMenu)
